import styled from "styled-components";
import { Row } from "antd";

export const OrangeButton = styled(Row)`
  padding: 16px;
  border: 1px solid rgba(255, 149, 0, 1);
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #ffffff;

  .btn-text {
    color: rgba(255, 149, 0, 1) !important; 
    transition: all 0.3s ease;
  }

  &:hover {
    background: rgba(255, 149, 0, 1);

    .btn-text {
      color: #ffffff !important;
    }
  }
`;

export const HoverRow = styled(Row)`
  border-radius: 12px;
  border: 1px solid #E5E9F2;
  padding: 16px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:has(${OrangeButton}:hover) {
    border: 1px solid rgba(255, 149, 0, 1);
    background: rgba(252, 248, 241, 1);
  }
`;